import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  setFilter,
  removeFilter,
  setPage,
  setSorter,
  getInitialProducts,
} from 'actions/productList';
import { fetchCurrentStaff } from 'actions/staffs';

let _content = null;

const ProductList = (props) => {
  const [overlay, setOverlay] = useState(false);

  const {
    setFilter,
    removeFilter,
    setPage,
    setSorter,
    getInitialProducts,
    location,
    match,
    fetchCurrentStaff
  } = props;

  useEffect(() => {
    initialProducts();
    fetchCurrentStaff()
  }, [location]);

  const triggerOverlay = (val) => {
    setOverlay(val);
  };

  const initialProducts = () => {
    const newUrl = location.pathname
      .split('/')
      .splice(2)
      .filter(Boolean)
      .join('/');
    const url = match.params.url ? newUrl : 'list';
    const object = {
      url: `${url ? url : ''}${location.search ? location.search : ''}`,
    };
    getInitialProducts(object);
  };

  const setFilterHandler = (search_key, values) => {
    const { facets, search_text } = props;
    const facetsKeys = Object.keys(facets);

    facetsKeys.forEach((key) => {
      if (facets[key].search_key === search_key) {
        facets[key].data.choices.forEach((choice) => {
          if (choice.value === values) {
            choice.is_selected = !choice.is_selected;
          }
        });
      }
    });

    setFilter(facets, search_text);
  };

  const setSorterHandler = (param) => {
    setSorter(param);
  };

  const emptyFilters = () => {
    initialProducts();
  };

  const removeFilterHandler = (search_key, value) => {
    removeFilter(search_key, value);
  };

  const setPageHandler = (page) => {
    setPage(page);
  };

  return (
    _content &&
    _content({
      overlay,
      props,
      triggerOverlay,
      initialProducts,
      setFilterHandler,
      setSorterHandler,
      emptyFilters,
      removeFilterHandler,
      setPageHandler,
    })
  );
};

const mapStateToProps = (state) => ({
  products: state.productList.products,
  facets: state.productList.facets,
  facetsApplied: state.productList.facetsApplied,
  sorters: state.productList.sorts,
  pending: state.productList.pending,
  pagination: state.productList.pagination,
  error: state.productList.error,
  search_text: state.productList.search_text,
  selectedCategory: state.navigation.selectedCategory,
});

const mapDispatchToProps = {
  setFilter,
  removeFilter,
  setPage,
  setSorter,
  getInitialProducts,
  fetchCurrentStaff
};

export default function (content) {
  _content = content;
  return connect(mapStateToProps, mapDispatchToProps)(ProductList);
}



// WEBPACK FOOTER //
// ./src/_pageContainers/product/list/index.js